import { ClientServicesTab } from './ClientServicesTab/ClientServicesTab.main';
import { EmployeeAdditionalInfoTab } from './EmployeeAdditionalInfoTab/EmployeeAdditionalInfoTab.main';
import { EmployeeInfoTab } from './EmployeeInfoTab/EmployeeInfoTab.main';
import { EmployeeSettingsTab } from './EmployeeSettingsTab';

export {
  EmployeeInfoTab,
  EmployeeAdditionalInfoTab,
  ClientServicesTab,
  EmployeeSettingsTab,
};
